import Vue from 'vue';

export function installFocusDirective() {
  Vue.directive('focus', {
    inserted: function(el) {
      el.focus();
    }
  });
}
